import { render, staticRenderFns } from "./BaseLabel.vue?vue&type=template&id=1743d20a&scoped=true"
import script from "./BaseLabel.vue?vue&type=script&lang=js"
export * from "./BaseLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1743d20a",
  null
  
)

export default component.exports